"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _zod = require("zod");

var _GroupItem = _interopRequireDefault(require("./GroupItem"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'group-overview_my_groups';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-group_overview-my_groups';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.undefined();

exports.config = config;

var MyGroupsOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MyGroupsOverview, _Component);

  var _super = _createSuper(MyGroupsOverview);

  function MyGroupsOverview() {
    (0, _classCallCheck2.default)(this, MyGroupsOverview);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(MyGroupsOverview, [{
    key: "render",
    value: function render() {
      var groups = this.props.groups;
      var myGroups = groups.myGroups;
      return (0, _preact.h)("div", {
        className: "sitewidth"
      }, (0, _preact.h)("div", {
        className: "group-overview-wrapper"
      }, (0, _preact.h)("div", {
        className: "sitewidth text-center"
      }, (0, _preact.h)("h1", {
        className: "group-overview-wrapper-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups"
      }))), myGroups.length ? (0, _preact.h)("div", {
        className: "groups--mine"
      }, (0, _preact.h)("h2", {
        className: "h4 group-overview-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.my.groups"
      })), (0, _preact.h)("div", {
        className: "group-overview"
      }, myGroups.map(function (group) {
        return (0, _preact.h)(_GroupItem.default, (0, _extends2.default)({
          hasWidgetTitle: true,
          hasWidgetSubtitle: false,
          key: group.id,
          isEvenCount: myGroups.length === 2 || myGroups.length === 4,
          isUserMember: true
        }, group, {
          showGroupMeta: false
        }));
      }))) : null));
    }
  }]);
  return MyGroupsOverview;
}(_preact.Component);

var _default = MyGroupsOverview;
exports.default = _default;